export const ortodonciaTypes = [
  {
    name: 'Brackets Metálicos',
    description: 'La opción más tradicional y efectiva. Fabricados en acero inoxidable de alta calidad, ofrecen resultados predecibles y duraderos para todo tipo de maloclusiones.',
    price: '2.500€',
    icon: 'ri-contrast-2-line'
  },
  {
    name: 'Brackets Estéticos',
    description: 'Fabricados en cerámica o zafiro, se mimetizan con el color natural de tus dientes. Perfectos para quienes buscan discreción sin renunciar a la efectividad.',
    price: '3.200€',
    icon: 'ri-sparkling-line'
  },
  {
    name: 'Ortodoncia Invisible',
    description: 'Alineadores transparentes removibles fabricados a medida. Tecnología de vanguardia que permite corregir tu sonrisa de forma prácticamente invisible.',
    price: '3.800€',
    icon: 'ri-eye-off-line'
  },
  {
    name: 'Ortodoncia Lingual',
    description: 'Brackets colocados en la cara interna de los dientes, completamente invisibles desde el exterior. La opción más discreta para profesionales exigentes.',
    price: '4.500€',
    icon: 'ri-shield-check-line'
  },
  {
    name: 'Ortodoncia Infantil',
    description: 'Tratamientos especializados para niños y adolescentes. Aprovechamos el crecimiento natural para guiar el desarrollo dental y facial de forma óptima.',
    price: '2.200€',
    icon: 'ri-emotion-happy-line'
  },
  {
    name: 'Ortodoncia Interceptiva',
    description: 'Tratamiento temprano enfocado en corregir problemas de desarrollo dental y esquelético durante la infancia, previniendo maloclusiones severas en la edad adulta.',
    price: '1.800€',
    icon: 'ri-seedling-line'
  },
  {
    name: 'Ortodoncia Pre Quirúrgica',
    description: 'Preparación ortodóncica previa a cirugía ortognática. Alineamos los dientes para optimizar los resultados quirúrgicos en casos de discrepancias esqueléticas severas.',
    price: '5.200€',
    icon: 'ri-surgical-mask-line'
  }
];